import * as React from 'react';

import { IAuthService } from '../../services/Interfaces/IAuthService';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { AppActionCreators, ApplicationState, AppState } from '../../store';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { ScaleLoader } from 'react-spinners';
import { Button, Grid, IconButton, List, ListItem } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import { withRouter } from 'react-router';
import moment from 'moment';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import CheckIcon from '@material-ui/icons/Check';
import { IAppUserService } from '../../services/Interfaces/IAppUserService';
import { IOrganizationService } from '../../services/Interfaces/IOrganizationService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CountryCodeEnum } from '../../helpers/Constants';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { NotificationItem, NotificationProps, UserNotificationProps } from '../../interfaces/Case';
import { UserNotification } from '../../interfaces/UserNotificationsUpdate';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICaseNewInNotificationState {}

class CaseNewInNotificationItem extends React.PureComponent<
  UserNotificationProps,
  ICaseNewInNotificationState
> {
  private authService!: IAuthService;
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appUserService!: IAppUserService;
  private organizationService!: IOrganizationService;

  static contextType = ApplicationContext;

  state = {} as ICaseNewInNotificationState;

  onClick = async (notificationId: number, caseId: number) => {
    try {
      await this.caseService.ReadUserNotification(notificationId);

      this.props.MarkAsViewedNotification(notificationId);

      const currentPath = this.props.history.location.pathname.toLowerCase();
      this.props.history.push('/cases/' + caseId);

      if (currentPath.indexOf('/cases/') !== -1) {
        this.props.history.go(0);
      }

      if (this.props.onClick !== undefined) {
        this.props.onClick();
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleDelete = async (notificationId: number) => {
    try {
      await this.caseService.DeleteUserNotification(notificationId);

      this.props.RemoveNotification(notificationId);
    } catch (err) {
      console.log(err);
    }
  };

  public render() {
    this.authService = (this.context as AppContext).authenticationService;
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appUserService = (this.context as AppContext).appUserService;
    this.organizationService = (this.context as AppContext).organizationService;

    const item = this.props.item.entity as UserNotification;
    const index = this.props.index;
    const isInPopup = this.props.item.isInPopup || false;

    return (
      <React.Fragment>
        <Grid container spacing={1}>
            <Grid item xs={1}>
            <div
                className={`p-0 ${!item.read ? 'font-weight-bold' : ''}`}
            >
                {index + 1}
            </div>
            </Grid>
            <Grid item xs={3}>
            <div
                className={`text-primary justify-content-start p-0 ${!item.read ? 'font-weight-bold' : ''}`}
                onClick={(e) => this.onClick(item.id, item.entityId)} 
                style={{ cursor: 'pointer' }}
            >
                {item.entityId}
            </div>
            <div className={`${!item.read ? 'font-weight-bold' : ''}`}>
                {item.details.statusDisplayName}
                {isInPopup && (
                    <FontAwesomeIcon 
                        icon={['far', 'folder-open']}
                        style={{ width: 20, height: 20, marginLeft: '10px' }}
                        className="align-self-center display-1"
                    />
                )}
            </div>
            {/* <div className="font-size-sm text-black-50">
                { item.details.caseNumber } 
            </div> */}
            </Grid>

            <Grid item xs={4}>
            <div className={`${!item.read ? 'font-weight-bold' : ''}`}>{item.details.categoryDisplayName}</div> 
            <div className="font-size-sm text-black-50">
                { item.details.vehiclePlateNumber }
            </div>
            </Grid>
            <Grid item xs={3}>
            <div className={`${!item.read ? 'font-weight-bold' : ''}`}>
                {this.props.appState.appUser?.organization?.country?.code?.toUpperCase() === CountryCodeEnum.CZ.toString() 
                  ? null : item.details.organizationOwnerName }
            </div>
            <div className="font-size-sm text-black-50">
                {moment
                .utc(item.dateCreation)
                .local()
                .format(this.props.appState.longDateFormat)}
            </div>
            </Grid>
            <Grid item container direction="column" xs={1}>
              <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => {
                    this.handleDelete(item.id);
                  }}                      
                  >
                  <DeleteOutlineTwoToneIcon />
              </IconButton>
            </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: NotificationProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  AppActionCreators,
  mergeProps
)(withRouter(CaseNewInNotificationItem as any));
